<dx-popup
    #taskViewerPopup
    [width]="width"
    [height]="height"
    container=".dx-viewport"
    [title]="title"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onTaskViewerShown()"
    (onHidden)="onTaskViewerClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form
                        *ngIf="projectTaskInfo"
                        width="100%"
                        height="100%"
                        [scrollingEnabled]="true"
                        [colCount]="1"
                    >
                        <dxi-item>
                            <dxo-label text="Community"></dxo-label>
                            <div *dxTemplate>
                                <div class="row-container">
                                    <div class="info-container">
                                        <dx-text-box
                                            class="text-content"
                                            [readOnly]="true"
                                            [value]="projectTaskInfo.community"
                                        ></dx-text-box>
                                    </div>
                                    <div class="notes-container">
                                        <app-notes-icon
                                            cssClass="fa-2x notes-container"
                                            [actionCode]="notesActionCode"
                                            [hasNotes]="projectTaskInfo.hasNote"
                                            (onNotesClick)="onNotesClick()"
                                        ></app-notes-icon>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Item"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [readOnly]="true" [value]="projectTaskInfo.item"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Short Description"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    [readOnly]="true"
                                    [maxHeight]="300"
                                    [value]="projectTaskInfo.item"
                                ></dx-text-area>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Responsible"></dxo-label>
                            <div *dxTemplate>
                                <app-user-bio-link
                                    [user]="projectTaskInfo.responsible"
                                    [communityId]="communityId"
                                ></app-user-bio-link>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Due Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    [readOnly]="true"
                                    [displayFormat]="dateFormat"
                                    [value]="projectTaskInfo.dueDate"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Status"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [readOnly]="true" [value]="projectTaskInfo.status"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Entered By"></dxo-label>
                            <div *dxTemplate>
                                <app-user-bio-link
                                    [user]="projectTaskInfo.enteredBy"
                                    [communityId]="communityId"
                                ></app-user-bio-link>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Entered On"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    [readOnly]="true"
                                    [displayFormat]="dateFormat"
                                    [value]="projectTaskInfo.enteredOn"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    text="Close"
                                    type="default"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onTaskViewerClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-project-task-notes-editor
    *ngIf="showNotesEditor"
    [visible]="showNotesEditor"
    [projectTaskId]="taskId"
    (onNotesEditorClose)="onNotesEditorClose($event)"
></app-project-task-notes-editor>
